/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';
    var launcher = require('modules/launcher/launcher');
    var core = require('core');
    var i18n = require('i18n');
    var device = require('util/device.util');
    var user = require('user');

    module.exports = {

        /**
         * Launch game
         * @param  {String} gameCode Model of Game
         * @param  {Number} mode "Real" or "Demo" mode for game
         * @param  {String=} queryString - additional URL params
         */
        launchGame: function(gameCode, mode, queryString, options) {
            // disable Game launch for Admin
            if (user.isAdmin()) {
                window.Playtech.API.popup.showPopup({
                    title: i18n.t('playtech.mobile.system.launcher.gameLaunchPopup.title'),
                    content: i18n.t('playtech.mobile.system.launcher.gameLaunchPopup.content')
                });

                return;
            }

            if (device.isMobilePlatform) {
                core.navigate(window.Playtech.Variables.downloadNativeAppPage || '/');
                window.Playtech.API.popup.closePopups('gameLaunch');
                return;
            }

            launcher.launchGame(gameCode, mode, queryString, options);
        }
    };
});
